import React from "react";
import axios from "axios";
import { ReactComponent as Print } from "../../../assets/icons/print.svg";
import { ReactComponent as ArrowDown } from "../../../assets/icons/arrowDown.svg";
import APIVariables from "../../../services/api-variables";
import LocalStorage from "../../../shared/localStorage";

import StyledViewCard from "./StyledViewCard";
import { handleCatch } from "../../../shared/helpers";

const ViewCard = ({ brochure, isBase64 }) => {
  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);
  const downloadBrochure = async (isPrint, id) => {
    axios
      .get(
        process.env.REACT_APP_BASE_URL +
          APIVariables.PATIENTS_BROCHURES_DOWNLOAD +
          id,
        {
          headers: {
            Authorization: parseLocalStorage.token,
          },
        }
      )
      .then((response) => {
        return response.data.report;
      })
      .then(async function (base64) {
        const base64Pdf = await fetch(`data:application/pdf;base64,${base64}`);
        return base64Pdf.blob();
      })
      .then((blob) => {
        const file = new Blob([blob], {
          type: "application/pdf",
        });
        const fileURL = URL.createObjectURL(file);
        const downloadLink = document.createElement("a");
        downloadLink.href = fileURL;
        if (isPrint) {
          if (
            !!brochure?.file_name &&
            !!brochure?.file_name.includes(".docx")
          ) {
            downloadLink.download = `${
              brochure?.file_name || brochure.name + ".pdf"
            }`;
            downloadLink.click();
            downloadLink.remove();
            URL.revokeObjectURL(downloadLink.href);
          } else {
            window.open(downloadLink.href);
          }
        } else {
          downloadLink.download = `${
            brochure?.file_name || brochure.name + ".pdf"
          }`;
          downloadLink.click();
          downloadLink.remove();
          URL.revokeObjectURL(downloadLink.href);
        }
      })
      .catch((error) => {
        handleCatch(error);
      });
  };
  return (
    <StyledViewCard>
      <img src={brochure.image} alt="" className="main-img" />
      <div className="wrapper-buttons">
        <div
          onClick={() => {
            downloadBrochure(true, brochure.id);
          }}
          file={brochure.file}
        >
          <span>Print</span> <Print />
        </div>
        {isBase64 ? (
          <button
            className="bg-transparent border-0 hover-class"
            onClick={() => {
              downloadBrochure(false, brochure.id);
            }}
          >
            <span>Download</span> <ArrowDown />
          </button>
        ) : (
          <a
            href={brochure.file}
            target={"_blank"}
            rel="noreferrer"
            download
            className="hover-class"
          >
            <span>Download</span>
            <ArrowDown />
          </a>
        )}
      </div>
    </StyledViewCard>
  );
};
export default ViewCard;
